<template>
    <div class="container">
        <div class="topIconText">
            <img v-if="itemData?.footerImage1?.display" :src="itemData?.footerImage1?.url" alt="" width="35%">
            <div class="welcomeText" v-if="itemData?.htmlWelcomeText?.display" v-html="itemData?.htmlWelcomeText?.text">
            </div>
            <div class="copywriteText" v-if="itemData?.htmlCopywriteText?.display"
                v-html="itemData?.htmlCopywriteText?.text"></div>
        </div>
        <div class="gameBrandContainer">
            <van-row style="padding: 15px 0;">
                <van-col span="12">{{ $t('home.gameGenre') }}</van-col>
                <van-col span="11" offset="1" style="text-align: left;">{{ $t('home.gameGenre') }}</van-col>
            </van-row>
            <van-row style="padding: 15px 0; font-weight: 400;">
                <van-col span="12">Slot</van-col>
                <van-col span="11" offset="1" class="gameCol" style="color: #616d93;">
                    <div v-for="(item,i) in groupList" :key="i">{{ item.name }}</div>
                </van-col>
            </van-row>
        </div>

        <div class="line"></div>
        <div class="content">
            <div v-html="footerHtmlText"></div>

        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, } from 'vue';
import { FooterImagesItem } from '@/view/home/supportScript';
import { useGameStore } from '@/stores/games';

const gameStore = useGameStore()
const footerHtmlText = ref('')
const groupList = computed(() => gameStore.groupList)
const props = defineProps<{
    itemData: {
        htmlText: string,
        footerImage1: FooterImagesItem,
        htmlWelcomeText: {
            display: boolean
            text: string
        },
        htmlCopywriteText: {
            display: boolean
            text: string
        }
    }
}>()
const emits = defineEmits(['openContactPopup'])
const openContactPopup = () => {
    emits('openContactPopup')
}
onMounted(() => {
    footerHtmlText.value = props.itemData.htmlText
})
</script>
<style scoped>
.container {
    padding: 10px 15px 50px;
    line-height: 20px;
    font-size: 14px;
}

.content :deep(*) {
    color: rgb(137 159 190 / var(--tw-text-opacity, 1)) !important;
}

.topIconText {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: rgb(137 159 190 / var(--tw-text-opacity, 1)) !important;
}

.ql-align-center {
    text-align: center !important;
}

.ql-align-center span {
    display: inline-block;
    width: 100%;
}


.ql-align-right {
    text-align: right !important;
}

.ql-align-right span {
    display: inline-block;
    width: 100%;
}

.ql-align-left {
    text-align: left !important;
}

.ql-align-left span {
    display: inline-block;
    width: 100%;
}

.line {
    height: 1px;
    width: 100%;
    background: #0e223e;
}

.welcomeText :deep(*) {
    color: rgba(255, 255, 255, .4) !important;
}

.copywriteText :deep(*) {
    color: #616d93 !important;
    font-weight: bold;
}

.gameBrandContainer {
    padding: 0 10% 25px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    font-size: 16px;
}
.gameCol{
    max-height: 120px;
    line-height: 25px;
    overflow: hidden;
    overflow-y: scroll;
    scrollbar-width: none;
    text-align: left;

}

.gameCol::-webkit-scrollbar {
  display: none;
}
</style>